module.exports = __webpack_public_path__ + "img/brushes-tablet_en.c04fc33.jpg";